import { Button, Popconfirm, Space } from "antd"
import { useNavigate } from "react-router-dom";
import TableComponent from "../../components/TableComponent";
import { deleteCode, getCodes } from "../../store/slices/codeSlice";
import { DeleteFilled, DeleteOutlined, EditOutlined } from "@ant-design/icons";
import { useDispatch } from "react-redux";
import { useState } from "react";
import { getPendingInvoice } from "../../store/slices/jobSlice";

const PendingInvoices = () => {
    const navigate = useNavigate();

    const columns = [
        {
            title: 'ID',
            dataIndex: '_id',
            key: '_id',
        },
        {
            title: 'First Name',
            dataIndex: 'first_name',
            key: 'first_name',
            render: (_, data) => {
                return `${data?.user_id?.first_name}`
            }
        },
        {
            title: 'Last Name',
            dataIndex: 'last_name',
            key: 'last_name',
            render: (_, data) => {
                return `${data?.user_id?.last_name}`
            }
        },
        {
            title: 'Actions',
            key: 'actions',
            render: (_, data) => (
                <Space>
                    <Button onClick={() => navigate('/invoice/edit/' + data?._id)} icon={<EditOutlined />} size="small">Edit</Button>
                </Space>
            ),
        },
    ];
    return (
        <div>
            <div style={{ marginBottom: 16, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <h1>Pending Invoices</h1>
                <Button type="primary" onClick={() => navigate('/invoice/add')}>Add Invoice</Button>
            </div>
            <TableComponent
                listData={getPendingInvoice}
                columns={columns}
                placeholder="Search..."
            />
        </div>
    )
}

export default PendingInvoices